var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 188,
    viewBox: "0 0 352 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_2288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3315 102.877C112.687 97.7508 140.005 88.6311 157.398 96.8633C174.85 105.123 151.004 119.5 152.336 131.75C153.604 143.413 176.278 154.404 164.744 164.43C151.019 176.36 121.597 184.272 95.5663 181.094C70.6345 178.051 60.8739 163.132 51.9196 150.658C45.1357 141.208 45.4279 131.173 53.0744 121.903C60.3917 113.031 74.4741 106.923 91.3315 102.877Z",
    fill: "#FC4820",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_2288",
    x: -202.208,
    y: -155.722,
    width: 619.493,
    height: 586.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_27_2288"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.d9f4b89b161c180285046a79dc31980e.svg";
export { ForwardRef as ReactComponent };